import React from 'react';

const Privacy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-medium tracking-wide mb-8">PRIVACY POLICY</h1>
      <p className="text-sm text-gray-500 mb-8">Last updated: January 2025</p>
      
      <div className="space-y-6 text-gray-700 text-sm leading-relaxed">
        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Introduction</h2>
          <p>
            At Dïtris, we respect your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or make a purchase from us.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Information We Collect</h2>
          <p className="mb-2">We collect information that you provide directly to us, including:</p>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Name, email address, phone number</li>
            <li>Shipping and billing addresses</li>
            <li>Payment information (processed securely through our payment providers)</li>
            <li>Order history and preferences</li>
            <li>Communications with our customer service team</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">How We Use Your Information</h2>
          <p className="mb-2">We use the information we collect to:</p>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Process and fulfill your orders</li>
            <li>Communicate with you about your orders and account</li>
            <li>Send you marketing communications (with your consent)</li>
            <li>Improve our products and services</li>
            <li>Detect and prevent fraud</li>
            <li>Comply with legal obligations</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Information Sharing</h2>
          <p>
            We do not sell or rent your personal information to third parties. We may share your information with:
          </p>
          <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
            <li>Service providers who assist with our operations (shipping, payment processing, marketing)</li>
            <li>Law enforcement or regulatory agencies when required by law</li>
            <li>Business partners with your explicit consent</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Cookies and Tracking</h2>
          <p>
            We use cookies and similar tracking technologies to enhance your browsing experience, analyze site traffic, and understand where our visitors are coming from. You can control cookies through your browser settings.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Your Rights</h2>
          <p className="mb-2">You have the right to:</p>
          <ul className="list-disc list-inside ml-4 space-y-1">
            <li>Access, correct, or delete your personal information</li>
            <li>Opt-out of marketing communications</li>
            <li>Request a copy of your data</li>
            <li>Lodge a complaint with a supervisory authority</li>
          </ul>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Children's Privacy</h2>
          <p>
            Our website is not intended for children under 13 years of age. We do not knowingly collect personal information from children.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
          </p>
        </div>

        <div>
          <h2 className="text-lg font-medium mb-3 text-black">Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy, please contact us at:
          </p>
          <p className="mt-2">
            Email: privacy@ditris.com<br />
            Phone: +1 (555) 123-4567<br />
            Address: 123 Fashion Street, New York, NY 10001
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;